import React, { Component } from 'react';
import { withRouter } from "react-router";
import Wizard from '../../../layouts/Wizard';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import * as apiServices from '../../../services/apiServices';
import { Program, ProgramForm } from '../../../core/model';
import { LoadingSpinnerPage } from '../../../components/atomic/Loaders/LoadingSpinner';
import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import { getResources } from '../../../modules/Resource';
import { setForm } from '../../../modules/ProgramForm';
import { setGlobalLoadingSpinner } from '../../../modules/GlobalUI';
import StatusSection from '../../../components/molecule/StatusIndicators/StatusSection';
import { toast } from 'react-toastify';
import ModalButton from '../../../components/atomic/Buttons/ModalButton';
import CreateProgramModal from '../../../components/molecule/Modals/CreateProgramModal'

// Components
import CreateForm from '../CreateForm';
import DetailForm from '../DetailForm';
import WellnessForm from '../WellnessForm';

const ButtonStyled = styled(Button)`
  margin-right: 12px;
`

const PublishContainer = styled.div`

`

class ProgramWizard extends Component {
  constructor(props) {
    super(props);
    this.inForm = true;
    this.state = {
      currentProgram: null,
      statusSectionOpen: false,
      isLoading: true,
    };
  }

  async componentDidMount() {
    const { match, getResources, resourceState, setForm } = this.props;
    try {
      const uid = match.params.uid;
      let data = null;
      if (uid != null) {
        data = await apiServices.getProgramByUid(uid);
      }
      if (!resourceState.resourceData) {
        await getResources();
      }
      const currentProgram = await this.formatDBForForm(data);
      const programForm = new ProgramForm();
      if (currentProgram) {
        programForm.formatForForm(currentProgram);
      }
      setForm(programForm, true);
      this.setState({
        currentProgram,
        isLoading: false,
      });
    } catch(e) {
      console.log('component: ',this,e.message);
      toast.error(e.message);
    }
  }

  formatDBForForm = async data => {
    const currentProgram = new Program();
    for (const key in data) {
      if (currentProgram.hasOwnProperty(key)) {
        currentProgram[key] = data[key];
      }
    }
    return currentProgram;
  }

  cancel = async () => {
    const { history, programFormState } = this.props;
    const programForm = programFormState.form;
    history.push(programForm.program_type === 'wellness' ? '/programs/wellness' : programForm.published ? '/programs' : '/programs/drafts');
    this.inForm = false;
  }

  save = (callback) => {
    const { history, programFormState } = this.props;
    const programForm = programFormState.form;
    this.submitForm(programForm, () => {
      if (callback) {
        callback();
      }
      history.push(programForm.program_type === 'wellness' ? '/programs/wellness' : programForm.published ? '/programs' : '/programs/drafts');
    });
  }

  publish = () => {
    const { history, programFormState } = this.props;
    const programForm = programFormState.form;
    programForm.published = true;
    this.submitForm(programForm, () => history.push('/programs'), 'publish');
  }

  unpublish = () => {
    const { history, programFormState } = this.props;
    const programForm = programFormState.form;
    programForm.published = false;
    this.submitForm(programForm, () => history.push('/programs/drafts'), 'unpublish');
  }

  copy = (programCopy) => {
    const { history, programFormState: { form }, setGlobalLoadingSpinner } = this.props;
    form.musclegroup = form.musclegroup?.map((muscle) => muscle?.id);
    form.fitnessgoals = form.fitnessgoals?.map((fitness) => fitness?.id);
    form.published = false;
    form.name = programCopy.name;
    form.copy = true;
    programCopy.program_type = 'wellness'
    
    setGlobalLoadingSpinner(true, 'Copying program...');
    apiServices.updateProgram(programCopy.id, form.formatforDB())
      .then(response => {
        toast.success(`Successfully copied program ${programCopy.name}`);
        history.push('/programs/wellness');
      })  
      .catch(e => {
        console.log('component:', this.e);
        toast.error(
          e.response.data.ValidationError ? e.response.data.ValidationError : e.message
        );
      });
  }

  submitForm = (form, callback, action = 'updated') => {
    const uid = form.id;

    let spinnerText = '';
    let toastText = '';

    switch(action) {
      case 'publish':
        spinnerText = 'publishing';
        toastText = 'published';
        break;
      case 'unpublish':
        spinnerText = 'unpublishing';
        toastText = 'unpublished';
        break;
      default:
        spinnerText = 'updating';
        toastText = 'updated';
        break;
    }

    this.props.setGlobalLoadingSpinner(true, `${spinnerText} program...`);
    apiServices.updateProgram(uid, form.formatforDB())
    .then(response => {
      toast.success(`Successfully ${toastText} program ${form.name}.`);
      if (callback) {
        callback();
      }
    })
    .catch(e => {
      console.log('component: ',this,e);
      toast.error(
        e.response.data.ValidationError ? e.response.data.ValidationError : e.message
      );
    })
  }

  getMissingFields = () => {
    const { programFormState } = this.props;
    const { statusSectionOpen } = this.state;
    const programForm = programFormState.form;
    if (programForm && programForm.primaryStatus !== 'Valid' && statusSectionOpen) {
      return <StatusSection onClose={() => this.setStatusSection(false)} statuses={programForm.statuses}/>
    } else {
      return null;
    }
  }

  setStatusSection = statusSectionOpen => this.setState({statusSectionOpen})

  render() {
    const { isLoading } = this.state;
    const { programFormState, ...others } = this.props;
    const programFrom = programFormState.form;
    const {
      programFormState: {
        clean,
        form: programForm,
      },
      ...other
    } = this.props;

    let isPublished = false;
    let isValid = false;
    
    if (programForm) {
      isPublished = programForm.published;
      isValid = programForm.primaryStatus === 'Valid';
    }

    return isLoading ? (
      <LoadingSpinnerPage />
    ) : (
      <Wizard
        clean={clean}
        form={programForm}
        disableFinish={isPublished ? !isValid : false}
        onFinish={this.save}
        onCancel={this.cancel}
        saveText="Save Program"
        wizardInfo={this.getMissingFields()}
        statusHeader="Publish Program"
        statusSubheader="Program can be published when the tasks below are complete."
        extraButtons={programForm.program_type === 'wellness' ? (<PublishContainer>
            <ModalButton variant='contained' color='secondary' modalComponent={(<CreateProgramModal onSuccess={this.copy} title={`Copy of ${programFrom.name}`} wellness={'wellness'}/>)}>
              Copy
            </ModalButton>
        </PublishContainer>) : (
          <PublishContainer>
            <ButtonStyled
              variant="contained"
              color="secondary"
              disabled={isPublished ? false : !isValid}
              onClick={isPublished ? () => this.unpublish() : () => this.publish()}
            >
              {isPublished ? 'Unpublish' : 'Publish'}
            </ButtonStyled>
          </PublishContainer>
        )}
        stepComponents={[
          {
            label: 'Create Program',
            component: programForm.program_type === 'wellness'
              ? <WellnessForm programData={programForm} {...other} />
              : <CreateForm programData={programForm} {...other} />,
          },
          {
            label: 'Program Details',
            component: <DetailForm programData={programForm} {...other} />,
          },
        ]}
      />
    )
  }
}

function mapStateToProps(state) {
  return {
    resourceState: state.resourceState,
    programFormState: state.programFormState,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    getResources: getResources,
    setForm: setForm,
    setGlobalLoadingSpinner: setGlobalLoadingSpinner
  }, dispatch)
}

export default compose(withRouter, connect(mapStateToProps,mapDispatchToProps))(ProgramWizard);
